import { OrgData } from "@types";
import { Feature } from "@utils";

export const generatePolicyLink = (org: OrgData, policy?: string): string => {
  return Feature.isNolicy({ org }) ? `board` : `policies/${policy}`;
};
